<template>
  <div class="report-area">
    <h1 class="h1">
      {{ $t('report.header') }}
    </h1>
    <p class="desc">
      {{ $t('report.header_desc') }}
    </p>
    <p class="desc">
      {{ $t('report.payouts') }}
    </p>
    <p class="desc hint">
      {{ $t('report.desc_hint1') }}
    </p>
    <p class="desc hint">
      {{ $t('report.desc_hint2') }}
    </p>
    <div class="h4">
      {{ $t('report.submit_header') }}:
    </div>
    <div class="form-area">
      <div class="input-area w-50">
        <label class="label">
          {{ $t('report.title') }}:
        </label>
        <input type="text" сlass="input" :placeholder="$t('report.title_plc')">
      </div>
      <div class="input-area w-50">
        <label class="label">
          {{ $t('report.email') }}:
        </label>
        <input type="text" сlass="input" :placeholder="$t('report.email_plc')">
      </div>
      <div class="input-area">
        <label class="label">
          {{ $t('report.level') }}:
        </label>
        <Select v-model="form.level" :options="levels" />
      </div>
      <div class="input-area">
        <label class="label">
          {{ $t('report.description') }}:
        </label>
        <textarea rows="6" сlass="input textarea" :placeholder="$t('report.description_plc')"></textarea>
      </div>
      <div class="buttons-area">
        <button type="button" :class="{'btn cyan': true, 'disabled': loading}" @click="submitReport">
          <span v-if="!loading">
            {{ $t('report.submit') }}
          </span>
          <span v-else>
            <Loading />
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  hydrateWhenIdle
} from 'vue-lazy-hydration'

export default {
  name: 'ReportComponent',
  components: {
    Loading: hydrateWhenIdle(() => import('~/components/svg/new/Loading')),
    Select: hydrateWhenIdle(() => import('~/components/app/interface/Select'))
  },
  layout: 'new',
  data() {
    return {
      loading: false,
      form: {
        title: '',
        email: '',
        description: '',
        level: 'info',
        images: []
      },
      levels: [
        {
          name: this.$t('report.info'),
          value: 'info'
        },
        {
          name: this.$t('report.minor'),
          value: 'minor'
        },
        {
          name: this.$t('report.medium'),
          value: 'medium'
        },
        {
          name: this.$t('report.high'),
          value: 'high'
        },
        {
          name: this.$t('report.critical'),
          value: 'critical'
        }
      ]
    }
  },
  async fetch({ store, error, route }) {
    try {
      const pageName = route.name.split('___')
      const seoData = store.getters['seos/seosByUri'](pageName[0])
      if (seoData === null) {
        await store.dispatch('seos/fetchSeos', {
          uri: route.name
        })
      }
    } catch (err) {
      error(err)
    }
  },
  head({ $config: { appUrl } }) {
    return {
      title: this.meta ? this.meta.title : this.$t('common.launching'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-description',
          name: 'og:description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-title',
          name: 'og:title',
          content: this.meta
            ? this.meta.title
            : this.$t('common.launching')
        },
        {
          hid: 'og-image',
          name: 'og:image',
          content: this.meta
            ? this.meta.image
            : appUrl + 'seo/default.jpg'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta ? this.meta.keyword : ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters('seos', [
      'seosByUri'
    ]),
    meta() {
      const pageName = this.$nuxt.$route.name.split('___')
      return this.seosByUri(pageName[0])
    }
  },
  methods: {
    submitReport() {
      alert('Report will be reviewed by our tech team in 1-3 days, you will be noticed about the results by your Email. Thanks for your support!')
    }
  }
}
</script>

<style scoped>
    @import url('~/assets/css/new/report.css');
</style>
